import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CartDrawer from "./CartDrawer";
import MobileBottomNav from "./MobileBottomNav";

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pb-16 lg:pb-0"><Outlet /></main>
      <Footer />
      <WhatsAppFloat />
      <CartDrawer />
      <MobileBottomNav />
    </div>
  );
}
